export default Vue => {
  Vue.component("v-searchable-select", () =>
    import("./v-searchable-select.vue")
  );
};
